var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-video-tailoring__ruler"},[_c('ul',{staticClass:"clearfix"},_vm._l((_vm.videoTimeData),function(item,index){return _c('li',{key:'ruler' + index},[(index % 10 == 0)?_c('div',{staticClass:"vh-video-tailoring__scale-tip"},[_vm._v(" "+_vm._s(_vm.scaleTime(index))+" ")]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }